/** @typedef {import("../../types").OcorrenciaSelecionada} OcorrenciaSelecionada */
/** @typedef {{ commit: Function }} ActionContextVisualizacao */

/**
 * Ações do store relatoOcorrencia/visualizacao.
 * Apenas commitam mutações síncronas para gerenciar a ocorrência selecionada.
 */
export default {
  /**
   * Salva a ocorrência selecionada no Vuex (chamado ao clicar na grid).
   * @param {ActionContextVisualizacao} context
   * @param {OcorrenciaSelecionada} ocorrencia - item emitido pelo grid container
   */
  selecionarOcorrencia({ commit }, ocorrencia) {
    commit("SET_OCORRENCIA_SELECIONADA", ocorrencia);
  },

  /**
   * Limpa a ocorrência selecionada do Vuex (chamado ao sair da tela de visualizar).
   * @param {ActionContextVisualizacao} context
   */
  limparOcorrenciaSelecionada({ commit }) {
    commit("LIMPAR_OCORRENCIA_SELECIONADA");
  }
};